/* gd-options.js — lógica das opções nativas (substitui o YMQ, 30-jul-2026).
   Vive num ASSET e usa delegação no document: sobrevive ao <product-rerender>
   do tema, que substitui o HTML da PDP (um <script> inline nunca voltaria a correr).

   31-jul: passou a tratar também a COBRANÇA. Descobrimos que o YMQ nunca usou Function
   nenhuma — criava uma draft order com o suplemento já somado na linha e mandava o
   cliente para o checkout dela (68% de todas as encomendas iam por aí). É por isso que
   o cliente via 1 artigo e o batch export sempre funcionou. Reproduzimos o mesmo, mas
   com código nosso: /apps/options/checkout.

   Regra de ouro deste ficheiro: NUNCA prender uma venda. Se o nosso lado falhar, tarda,
   ou a app estiver desligada, o cliente segue para o checkout normal da Shopify — no
   pior caso paga sem o suplemento, que é exatamente o que acontece hoje. */
(function () {
  'use strict';
  if (window.__gdOptions) return;
  window.__gdOptions = 1;

  var boxOf = function (el) { return el && el.closest ? el.closest('form[action*="/cart/add"]') : null; };
  var q = function (form, sel) { return form ? form.querySelector(sel) : null; };

  function sync(form) {
    var perso = q(form, '[data-gd-perso]');
    if (perso) {
      var on = perso.value !== 'Pas de Personnalisation';
      var wrap = q(form, '[data-gd-nom]');
      var inp = q(form, '[data-gd-nom-input]');
      /* O nome e o número são dois campos; a PROPRIEDADE continua uma só, montada aqui.
         O `required` vive no campo do NOME — é o único visível que o browser pode
         travar — e o número fica opcional, como sempre foi (há quem queira só o nome). */
      var cNome = q(form, '[data-gd-nom-nome]');
      var cNum = q(form, '[data-gd-nom-num]');
      if (wrap) wrap.hidden = !on;
      if (cNome) cNome.required = on;
      if (!on) {
        if (cNome) cNome.value = '';
        if (cNum) cNum.value = '';
      }
      if (inp) {
        var nome = cNome ? cNome.value.trim().toUpperCase() : '';
        var num = cNum ? cNum.value.replace(/\D/g, '') : '';
        inp.value = on ? (nome + (num ? ' ' + num : '')).trim() : '';
      }
      var card = q(form, '[data-gd-perso-card]');
      if (card) {
        card.classList.toggle('gd-open', on);          /* o nosso estado, manda no CSS */
        card.classList.toggle('pdp-perso-open', on);
      }
      /* o JS do pdp-wow procura ESTA classe para saber se o bloco seguinte está escondido.
         Sem ela, ele assume "aberto" e encolhe o padding de baixo para 4px. */
      if (wrap) wrap.classList.toggle('ymq-option-condition-hide', !on);

      /* EMBLEMA A 5,99 COM NOME E NÚMERO (7-ago). O preço tem de MUDAR à vista: se a ficha
         disser 7,99 e o carrinho cobrar 5,99, o incentivo não existe — e é o incentivo que
         é o ponto (61 das 182 encomendas de 1 artigo levaram nome e número e recusaram o
         emblema ao mesmo preço).
         Os dois valores vêm do Liquid já formatados em `money`, para não haver aqui uma
         segunda ideia de como se escreve um preço. E só se escreve no DOM quando MUDA:
         escrever sempre é o que já pôs esta página em ciclo com um observer. */
      var pPatch = q(form, '[data-gd-patch-preco]');
      if (pPatch) {
        var rot = on ? pPatch.getAttribute('data-com-perso') : pPatch.getAttribute('data-sem-perso');
        if (rot && pPatch.textContent !== rot) pPatch.textContent = rot;
        /* o 7,99 riscado acompanha o 5,99: só existe enquanto a personalização está
           ligada — sem par, o riscado não é referência, é ruído */
        var pAntes = q(form, '[data-gd-patch-antes]');
        if (pAntes && pAntes.hidden !== !on) pAntes.hidden = !on;
      }
    }
    var short = q(form, '[data-gd-short]'), ss = q(form, '[data-gd-short-size]');
    if (short && ss) {
      var onS = short.value === 'Oui';
      ss.hidden = !onS;
      var st = q(form, '[data-gd-short-title]');   /* «Taille du short» acompanha o seletor */
      if (st) st.hidden = !onS;
      var errS = q(form, '[data-gd-err-short]');
      if (errS && !onS) errS.hidden = true;
      if (!onS) {                                   /* repõe se voltar a Non */
        var h = ss.querySelector('input[type=hidden]');
        if (h) h.value = '';
        ss.querySelectorAll('[data-gd-pill]').forEach(function (p) {
          p.classList.remove('is-selected'); p.setAttribute('aria-pressed', 'false');
        });
      }

      /* MEIAS INCLUÍDAS NOS CALÇÕES (31-jul). Os calções passaram a 24,90 € e levam-nas.
         Sem isto o cliente pagava os 24,90 e saía sem as meias, porque o servidor só
         desconta o que vem escolhido na propriedade — não adivinha a intenção. */
      var socks = q(form, '[data-gd-socks]');
      var caixaS = q(form, '[data-gd-socks-box]');
      if (socks) {
        var grupoS = q(form, '[data-gd-group="socks"]');
        if (onS) {
          socks.value = 'Oui';                      /* a propriedade tem de ir preenchida */
          if (grupoS) {
            grupoS.querySelectorAll('[data-gd-pill]').forEach(function (p) {
              var sim = p.dataset.value === 'Oui';
              p.classList.toggle('is-selected', sim);
              p.setAttribute('aria-pressed', sim ? 'true' : 'false');
            });
            marcarToggle(grupoS, true);
          }
          /* esconde-se o bloco todo: mantê-lo a pedir 7,90 € por baixo de «offertes»
             dizia duas coisas ao mesmo tempo, e a que o cliente acredita é a que lhe
             custa dinheiro. O valor segue no input escondido, que é o que conta. */
          if (caixaS) caixaS.hidden = true;
        } else {
          if (caixaS) caixaS.hidden = false;
          if (socks.value === 'Oui' && socks.dataset.auto === '1') {
            socks.value = 'Non';
            marcarToggle(q(form, '[data-gd-group="socks"]'), false);
          }
        }
        socks.dataset.auto = onS ? '1' : '';        /* só se repõe o que fomos NÓS a pôr */
      }
    }

    /* ── A LINHA CONFIRMA O QUE FICOU ──
       Depois de «Ajouté», a linha do argumento não tem de continuar a dizer o que a
       opção É: passa a dizer o que o cliente ESCOLHEU — «MARTIN 10», «Taille M». Zero
       elementos novos, o mesmo sítio com outro conteúdo; é o que faz a ficha parecer que
       está a acompanhar em vez de estar à espera. Guarda-se o texto de origem na 1ª vez
       e recalcula-se sempre a partir dele. */
    (function () {
      var escreve = function (arg, txt) {
        if (!arg) return;
        if (arg.dataset.base === undefined) arg.dataset.base = arg.textContent.trim();
        var novo = txt || arg.dataset.base;
        if (arg.textContent.trim() !== novo) arg.textContent = novo;
      };
      var cartao = q(form, '[data-gd-perso-card]');
      if (cartao && perso) {
        escreve(cartao.querySelector('.gd-opt__arg'),
          perso.value !== 'Pas de Personnalisation' && inp && inp.value ? inp.value : '');
      }
      var caixaCurta = q(form, '[ymq-option-label="Short d\'Équipement"]');
      if (caixaCurta && short) {
        var ts = q(form, '[data-gd-short-size] input[type=hidden]');
        var base = caixaCurta.querySelector('.gd-opt__arg');
        var rot = ts && ts.value === 'XXL' ? '2XL' : (ts ? ts.value : '');
        /* escolhido e com tamanho, a linha diz só «Taille M»: a oferta das meias já foi
           feita e repeti-la aqui só servia para o texto encolher em reticências */
        escreve(base, short.value === 'Oui' && rot ? 'Taille ' + rot : '');
      }
    })();

    /* o preço do botão segue a escolha, não a página: cada toque numa pastilha passa
       por aqui. A tabela pode ainda não ter chegado — quando chegar, a repintura geral
       volta a passar pelos botões. */
    var lupaAberta = document.querySelector('.gd-lupa.is-open');
    if (lupaAberta) lupaSincronizaBotao(lupaAberta);

    if (FAMS) pintarBotao(form); else loadTable(function () { pintarBotao(form); });
  }

  /* tooltip: toque abre/fecha no telemóvel (o :hover não existe lá) */
  document.addEventListener('click', function (e) {
    var tip = e.target.closest ? e.target.closest('[data-gd-tip]') : null;
    document.querySelectorAll('[data-gd-tip].is-open').forEach(function (o) {
      if (o !== tip) { o.classList.remove('is-open'); o.setAttribute('aria-expanded', 'false'); }
    });
    if (!tip) return;
    e.preventDefault(); e.stopPropagation();
    var on = !tip.classList.contains('is-open');
    tip.classList.toggle('is-open', on);
    tip.setAttribute('aria-expanded', on ? 'true' : 'false');
  }, false);

  /* ── lupa dos patches ──
     O bordado tem 44px na grelha e o cliente vai pagar 4,99 € por ele: o 2º toque no
     que já está escolhido abre-o em grande. Construída à mão para não depender do
     modal do tema (que já nos deu problemas de foco). */
  /* Passou a GALERIA: os patches abrem uma foto só, o calção abre as que o produto tem
     e anda-se de lado. Um calção a 24,90 € é a opção mais cara da ficha e o cliente
     nunca lhe viu as costas — as fotos existem todas, só não estavam ao alcance. */
  var lupaFotos = [];
  var lupaI = 0;
  var lupaAntesScroll = 0;

  /* Trocar o src a seco dava um piscar branco entre fotos — o browser larga a antiga
     antes de ter a nova. Descarrega-se a seguinte em silêncio e só depois se troca,
     com um fundido curto por cima. */
  function lupaPreload(i) {
    var u = lupaFotos[(i + lupaFotos.length) % lupaFotos.length];
    if (u) { var im = new Image(); im.src = u; }
  }

  function lupaPinta(l, animar) {
    var img = l.querySelector('.gd-lupa__foto');
    var troca = function () {
      img.src = lupaFotos[lupaI];
      img.classList.remove('is-fade');
    };
    if (animar) {
      img.classList.add('is-fade');
      var pronta = new Image();
      pronta.onload = pronta.onerror = troca;
      pronta.src = lupaFotos[lupaI];
      /* se a rede engasgar, não se fica com a foto apagada à espera */
      setTimeout(troca, 260);
    } else {
      troca();
    }

    var varias = lupaFotos.length > 1;
    l.classList.toggle('tem-varias', varias);
    l.querySelector('.gd-lupa__conta').textContent = varias ? (lupaI + 1) + ' / ' + lupaFotos.length : '';
    var pontos = l.querySelector('.gd-lupa__pontos');
    if (varias && pontos.children.length !== lupaFotos.length) {
      pontos.innerHTML = lupaFotos.map(function () { return '<i></i>'; }).join('');
    }
    Array.prototype.forEach.call(pontos.children, function (p, i) {
      p.className = i === lupaI ? 'is-on' : '';
    });
    lupaPreload(lupaI + 1);
    lupaPreload(lupaI - 1);
  }

  function lupaAnda(l, d) {
    if (lupaFotos.length < 2 || l.classList.contains('gd-lupa--par')) return;
    /* dá a volta: chegar ao fim e continuar é o gesto natural num carrossel */
    lupaI = (lupaI + d + lupaFotos.length) % lupaFotos.length;
    lupaPinta(l, true);
  }

  /* A lupa não é só uma foto grande: é onde a pessoa vai VER se quer aquilo. Por isso
     leva a opção com ela — nome, preço e o mesmo botão da linha. Quem abre para decidir
     decide ali, sem ter de fechar, procurar a linha certa e carregar noutro sítio. */
  var lupaCtx = null;

  function lupaSincronizaBotao(l) {
    var b = l.querySelector('.gd-lupa__add');
    if (!b) return;
    var ligado = !!(lupaCtx && lupaCtx.toggle && lupaCtx.toggle.getAttribute('aria-pressed') === 'true');
    b.hidden = !(lupaCtx && lupaCtx.toggle);
    b.setAttribute('aria-pressed', ligado ? 'true' : 'false');
    var p = b.querySelector('.gd-lupa__add-preco');
    if (p) p.textContent = (lupaCtx && lupaCtx.preco) || '';
  }

  /* MODO PAR: os dois emblemas do Mundial vão na MESMA camisola, um por manga. Folheá-los
     um a um dizia que eram alternativas — mostram-se lado a lado, de uma vez, e as setas,
     os pontos e o contador saem de cena porque não há nada para percorrer. */
  function lupaPintaPar(l) {
    var caixa = l.querySelector('.gd-lupa__par');
    caixa.innerHTML = lupaFotos.map(function (u) {
      return '<img src="' + u + '" alt="" draggable="false">';
    }).join('');
  }

  function abrirLupa(fotos, nome, inicio, ctx) {
    lupaFotos = [].concat(fotos).filter(Boolean);
    if (!lupaFotos.length) return;
    lupaCtx = ctx || null;
    lupaI = Math.max(0, Math.min(lupaFotos.length - 1, inicio || 0));

    var l = document.querySelector('.gd-lupa');
    if (!l) {
      l = document.createElement('div');
      l.className = 'gd-lupa';
      l.innerHTML = '<div class="gd-lupa__caixa" role="dialog" aria-modal="true" aria-label="Photos">' +
        '<button type="button" class="gd-lupa__x" aria-label="Fermer">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<div class="gd-lupa__palco">' +
        '<button type="button" class="gd-lupa__seta gd-lupa__seta--ant" aria-label="Précédent">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
        '<img class="gd-lupa__foto" alt="" draggable="false">' +
        '<div class="gd-lupa__par"></div>' +
        '<button type="button" class="gd-lupa__seta gd-lupa__seta--seg" aria-label="Suivant">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
        '</div>' +
        '<div class="gd-lupa__pe">' +
        '<div class="gd-lupa__pontos"></div>' +
        '<span class="gd-lupa__conta"></span>' +
        '<p class="gd-lupa__nome"></p>' +
        '<button type="button" class="gd-lupa__add gd-opt__add" aria-pressed="false" hidden>' +
        '<svg class="gd-opt__add-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5l5.5 5.5L20 6.5"/></svg>' +
        '<span class="gd-opt__add-off">Ajouter</span><span class="gd-opt__add-on">Ajouté</span>' +
        '<span class="gd-lupa__add-preco"></span></button>' +
        '</div></div>';
      document.body.appendChild(l);

      /* trava o scroll da página: sem isto, arrastar na foto rolava a ficha por trás e
         a galeria parecia estar a saltar */
      var fechar = function () {
        l.classList.remove('is-open');
        document.body.classList.remove('gd-lupa-aberta');
        document.body.style.top = '';
        window.scrollTo(0, lupaAntesScroll);
      };
      l.__fechar = fechar;

      l.addEventListener('click', function (e) {
        var add = e.target.closest ? e.target.closest('.gd-lupa__add') : null;
        if (add) {
          /* carrega no botão da LINHA: um caminho só para acrescentar, e a linha lá
             atrás fica com o estado certo quando a lupa fechar */
          if (lupaCtx && lupaCtx.toggle) lupaCtx.toggle.click();
          lupaSincronizaBotao(l);
          return;
        }
        var seta = e.target.closest ? e.target.closest('.gd-lupa__seta') : null;
        if (seta) { lupaAnda(l, seta.classList.contains('gd-lupa__seta--seg') ? 1 : -1); return; }
        if (e.target.closest && e.target.closest('.gd-lupa__x')) { fechar(); return; }
        /* clicar fora da caixa fecha; na foto, não */
        if (!e.target.closest || !e.target.closest('.gd-lupa__caixa')) fechar();
      });
      document.addEventListener('keydown', function (e) {
        if (!l.classList.contains('is-open')) return;
        if (e.key === 'Escape') fechar();
        else if (e.key === 'ArrowRight') lupaAnda(l, 1);
        else if (e.key === 'ArrowLeft') lupaAnda(l, -1);
      });
      /* arrastar com o dedo: é assim que se anda numa galeria no telemóvel, e é no
         telemóvel que a ficha vive. Só conta o gesto HORIZONTAL — um deslize vertical
         é intenção de fechar/rolar, não de mudar de foto. */
      var x0 = null, y0 = null;
      l.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      l.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) lupaAnda(l, dx < 0 ? 1 : -1);
      }, { passive: true });
    }
    l.querySelector('.gd-lupa__nome').textContent = nome || '';
    lupaSincronizaBotao(l);
    var par = !!(lupaCtx && lupaCtx.par) && lupaFotos.length > 1;
    l.classList.toggle('gd-lupa--par', par);
    if (par) lupaPintaPar(l); else lupaPinta(l, false);
    lupaAntesScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.classList.add('gd-lupa-aberta');
    document.body.style.top = (-lupaAntesScroll) + 'px';
    l.classList.add('is-open');
    var x = l.querySelector('.gd-lupa__x');
    if (x && x.focus) { try { x.focus({ preventScroll: true }); } catch (err) { x.focus(); } }
  }

  /* a miniatura do calção abre a galeria do produto do calção */
  document.addEventListener('click', function (e) {
    var alvo = e.target.closest ? e.target.closest('[data-gd-galeria]') : null;
    if (!alvo) return;
    e.preventDefault();
    var fotos = (alvo.getAttribute('data-gd-galeria') || '').split('|').filter(Boolean);
    /* abre na foto que a miniatura mostra: as duas saem do mesmo ficheiro, só com
       larguras diferentes, por isso compara-se o caminho sem os parâmetros */
    var mini = alvo.querySelector('img');
    var chave = mini ? String(mini.getAttribute('src') || '').split('?')[0] : '';
    var i = chave ? fotos.findIndex(function (u) { return u.split('?')[0] === chave; }) : -1;
    var caixa = alvo.closest('.ymq-options-box');
    var preco = caixa ? caixa.querySelector('.gd-opt__preco') : null;
    abrirLupa(fotos, alvo.getAttribute('data-gd-galeria-nome') || '', i < 0 ? 0 : i, {
      toggle: caixa ? caixa.querySelector('[data-gd-toggle]') : null,
      preco: preco ? preco.textContent.trim() : '',
      /* a peça com dois emblemas é a que traz `--duo`: são um par, não uma galeria */
      par: alvo.classList.contains('gd-opt__peca--duo'),
    });
  }, false);

  /* ── o botão «Ajouter» ──
     Um só controlo por opção, em vez do par Non/Oui. O valor continua a viver no input
     escondido, com exatamente as mesmas palavras de sempre («Oui»/«Non», «Nom et
     Numéro»/«Pas de Personnalisation») — o fornecedor, o batch export e quem cobra não
     dão por nada. */
  function marcarToggle(grupo, ligado) {
    if (!grupo) return;
    var b = grupo.querySelector('[data-gd-toggle]');
    if (b && (b.getAttribute('aria-pressed') === 'true') !== ligado) {
      b.setAttribute('aria-pressed', ligado ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gd-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    var grupo = btn.closest('[data-gd-group]');
    var input = grupo ? grupo.querySelector('input[type=hidden]') : null;
    if (!input) return;
    var ligado = btn.getAttribute('aria-pressed') !== 'true';
    btn.setAttribute('aria-pressed', ligado ? 'true' : 'false');
    input.value = ligado ? (btn.dataset.valueOn || '') : (btn.dataset.valueOff || '');
    grupo.classList.remove('gd-opt--invalid');
    var err = grupo.parentNode ? grupo.parentNode.querySelector('[data-gd-err]') : null;
    if (err) err.hidden = true;
    sync(boxOf(btn));
  }, false);

  /* pills -> escreve no input escondido */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest ? e.target.closest('[data-gd-pill]') : null;
    if (!pill) return;
    e.preventDefault();

    /* 2º toque num patch já escolhido → ver em grande, sem mexer na escolha */
    if (pill.classList.contains('gd-patch') && pill.classList.contains('is-selected')) {
      var imgs = pill.querySelectorAll('img');
      if (imgs.length && imgs[0].dataset.grande) {
        /* uma camisola do Mundial leva dois emblemas: abrem os dois, um a seguir ao outro */
        abrirLupa([].map.call(imgs, function (im) { return im.dataset.grande; }),
          pill.getAttribute('title') || '', 0);
        return;
      }
    }

    var group = pill.closest('[data-gd-group]');
    var input = group.querySelector('input[type=hidden]');
    group.querySelectorAll('[data-gd-pill]').forEach(function (p) {
      p.classList.toggle('is-selected', p === pill);
      p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
    });
    input.value = pill.dataset.value;
    group.classList.remove('gd-opt--invalid');
    var err = group.parentNode.querySelector('[data-gd-err]');
    if (err) err.hidden = true;
    sync(boxOf(pill));
  }, false);

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('[data-gd-options]')) sync(boxOf(e.target));
  }, false);

  /* a cada tecla: o número só aceita algarismos e a propriedade recompõe-se — sem isto
     o «MARTIN 10» só ficava montado quando o campo perdia o foco */
  document.addEventListener('input', function (e) {
    var alvo = e.target.closest ? e.target.closest('[data-gd-nom-nome], [data-gd-nom-num]') : null;
    if (!alvo) return;
    var errN2 = alvo.closest('[data-gd-nom]');
    errN2 = errN2 ? errN2.querySelector('[data-gd-err-nom]') : null;
    if (errN2 && !errN2.hidden) errN2.hidden = true;
    if (alvo.hasAttribute('data-gd-nom-num')) {
      var so = alvo.value.replace(/\D/g, '').slice(0, 2);
      if (alvo.value !== so) alvo.value = so;
    }
    sync(boxOf(alvo));
  }, false);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(sync);
  });

  /* ── tamanho obrigatório antes de adicionar ao carrinho ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.product-form__add-button') : null;
    if (!btn) return;
    var form = boxOf(btn);
    if (!form || !q(form, '[data-gd-options]')) return;

    function falta(grupoSel, erroSel, alvo) {
      e.preventDefault(); e.stopImmediatePropagation();
      var group = q(form, grupoSel), err = q(form, erroSel);
      if (group) group.classList.add('gd-opt--invalid');
      if (err) err.hidden = false;
      (group || alvo).scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    /* tamanho do artigo */
    var hid = q(form, '[data-gd-required]');
    if (hid && !hid.value) return falta('[data-gd-group="taille"]', '[data-gd-err]', hid);

    /* PERSONALIZAÇÃO ESCOLHIDA E SEM NADA ESCRITO.
       O `required` do campo do nome não chega: o «Ajouter au panier» deste tema é AJAX e
       nunca passa pela validação nativa do formulário — a encomenda entrava com
       «Personnalisation: Nom et Numéro» e nada para flocar, e é o fornecedor que fica à
       espera de um nome que ninguém escreveu. Basta um dos dois campos: há quem queira só
       o número. */
    var pv = q(form, '[data-gd-perso]');
    if (pv && pv.value !== 'Pas de Personnalisation') {
      var nomInp = q(form, '[data-gd-nom-input]');
      if (nomInp && !nomInp.value.trim()) {
        e.preventDefault(); e.stopImmediatePropagation();
        var errN = q(form, '[data-gd-err-nom]');
        if (errN) errN.hidden = false;
        var alvoN = q(form, '[data-gd-nom-nome]') || nomInp;
        alvoN.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (alvoN.focus) { try { alvoN.focus({ preventScroll: true }); } catch (_) { alvoN.focus(); } }
        return;
      }
    }

    /* tamanho do SHORT — só obrigatório quando o short foi escolhido. Sem isto dava
       para adicionar «Oui +19,90 €» sem dizer o tamanho, e a encomenda chegava ao
       fornecedor sem saber o que enviar. */
    var sh = q(form, '[data-gd-short]');
    if (sh && sh.value === 'Oui') {
      var shSize = q(form, '[data-gd-short-size] input[type=hidden]');
      if (shSize && !shSize.value) return falta('[data-gd-group="short-size"]', '[data-gd-err-short]', shSize);
    }
  }, true);

  /* Rede de segurança: o mesmo travão no SUBMIT do formulário. O clique é o caminho
     normal, mas há outros (Enter num campo, a barra fixa, código do tema) e nenhum deles
     pode entregar uma encomenda sem tamanho ou com a personalização vazia. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    if (!q(form, '[data-gd-options]')) return;
    var hid = q(form, '[data-gd-required]');
    var pv = q(form, '[data-gd-perso]');
    var nomInp = q(form, '[data-gd-nom-input]');
    var sh = q(form, '[data-gd-short]');
    var shSize = q(form, '[data-gd-short-size] input[type=hidden]');
    var falha = (hid && !hid.value)
      || (pv && pv.value !== 'Pas de Personnalisation' && nomInp && !nomInp.value.trim())
      || (sh && sh.value === 'Oui' && shSize && !shSize.value);
    if (!falha) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var btn = q(form, '.product-form__add-button');
    if (btn) btn.click();          /* reaproveita o caminho normal: marca, avisa e leva lá */
  }, true);

  /* ═══════════════════════════════════════════════════════════════════════
     COBRANÇA DAS OPÇÕES — interceção do checkout
     ═══════════════════════════════════════════════════════════════════════
     O carrinho da Shopify não sabe somar 4,99 € a uma linha existente. Quem sabe é a
     nossa app: cria uma draft order com o preço certo e devolve o link do checkout.

     O interruptor vive no SERVIDOR (settings.gd_options_charge) e é lido no arranque,
     não no clique — com a cobrança desligada não gastamos um milissegundo do cliente. */

  var CFG = { charge: false, mode: 'false', loaded: false };

  /* Modo de teste: abrir a loja com ?gd_test=1 marca ESTE browser. Com o interruptor do
     servidor em 'test', só quem tiver esta marca é cobrado — o 1º ensaio a sério não cai
     em cima de um cliente. ?gd_test=0 desliga. */
  var TEST_KEY = 'gdOptTest';

  function setCookie(v) {
    try {
      document.cookie = TEST_KEY + '=' + v + '; path=/; max-age=' + (v ? 86400 : 0) + '; SameSite=Lax';
    } catch (_) {}
  }
  function hasCookie() {
    try { return document.cookie.indexOf(TEST_KEY + '=1') !== -1; } catch (_) { return false; }
  }

  try {
    var m = /[?&]gd_test=([01])/.exec(location.search);
    if (m) {
      if (m[1] === '1') { try { localStorage.setItem(TEST_KEY, '1'); } catch (_) {} setCookie('1'); }
      else { try { localStorage.removeItem(TEST_KEY); } catch (_) {} setCookie(''); }
      try { localStorage.removeItem('gdOptCfg'); } catch (_) {}
    }
  } catch (_) {}

  /* Cookie E localStorage: em janela anónima (e com storage bloqueado) um deles
     costuma sobreviver. Basta um para nos reconhecer. */
  /* previsualização dos patches: o bloco vem escondido do servidor e só o testador o vê */
  function revelarPrevia() {
    if (!isTester()) return;
    document.querySelectorAll('.gd-opt__previa').forEach(function (el) { el.classList.add('gd-previa-on'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revelarPrevia);
  else revelarPrevia();

  function isTester() {
    if (hasCookie()) return true;
    try { return localStorage.getItem(TEST_KEY) === '1'; } catch (_) { return false; }
  }

  /* Cache de sessão: 1 pedido por visita, não 1 por página. O drawer existe em todas
     as páginas — sem isto púnhamos o nosso servidor no caminho de cada page view. */
  /* localStorage, não sessionStorage: assim a 2ª página já não espera pela rede.
     TTL curto na config (é o interruptor de cobrança — não pode ficar velha),
     longo na tabela (os preços mudam de mês a mês, não de minuto a minuto). */
  var CACHE_KEY = 'gdOptCfg', CACHE_TTL = 60 * 1000;
  var TABLE_TTL = 24 * 60 * 60 * 1000;
  function guardar(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) {} }
  function ler(k, ttl) {
    try { var c = JSON.parse(localStorage.getItem(k) || 'null'); return (c && Date.now() - c.at < ttl) ? c : null; } catch (_) { return null; }
  }

  function loadConfig() {
    var c = ler(CACHE_KEY, CACHE_TTL);
    if (c && c.mode) { CFG.charge = !!c.charge; CFG.mode = c.mode; CFG.loaded = true; agendarPintura(0); }

    fetch('/apps/options/config', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return;
        CFG.charge = !!j.charge; CFG.mode = j.mode || 'false'; CFG.loaded = true;
        guardar(CACHE_KEY, { charge: CFG.charge, mode: CFG.mode, at: Date.now() });
        agendarPintura();   /* a config chegou depois da 1ª tentativa de pintura */
      })
      .catch(function () { /* offline/erro: ficamos fora do caminho */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadConfig);
  else loadConfig();


  /* ═══════════════════════════════════════════════════════════════════════
     PINTURA DO CARRINHO
     ═══════════════════════════════════════════════════════════════════════
     O carrinho da Shopify guarda 39,99 — não sabe somar os 4,99 da personalização a uma
     linha. O YMQ resolvia isto reescrevendo os preços no ECRÃ (os ganchos que ele deixou,
     `ymq_item_final_price` / `ymq_cart_total_price`, ainda estão no main-cart.liquid).
     Fazemos o mesmo. Isto é só a montra: quem cobra é a draft, no checkout.

     Regra: nunca partir o carrinho. Se a tabela não chegar, ou um preço não for legível,
     não se pinta nada — o cliente vê o preço da Shopify, como vê hoje. */

  var TABLE = null;
  var TABLE_KEY = 'gdOptTable';

  function normKey(s) {
    return String(s == null ? '' : s).normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/&#0*39;|&apos;|&rsquo;/gi, "'").replace(/[‘’ʼ´`]/g, "'")
      .replace(/\s*\(\+[^)]*\)\s*$/, '')
      .replace(/\s*\|\s*(€|CHF|EUR)\s*[\d.,]+\s*$/i, '')
      .replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function surchargeCents(props) {
    if (!TABLE || !props) return 0;
    var total = 0;
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      if (k.charAt(0) === '_') continue;
      var g = TABLE[normKey(k)];
      if (!g) continue;
      var c = g[normKey(props[k])];
      if (typeof c === 'number') total += c;
    }
    return total;
  }

  /* Preços POR FAMÍLIA (as meias custam 7,90 num maillot e 5,99 num kit, e um kit nem
     sequer tem calções) + a regra do emblema, que não cabe numa tabela valor→preço.
     Chave de cache nova de propósito: a antiga guardava a tabela achatada de antes de
     31-jul, com os calções ainda a 19,90 — um cliente com essa cópia veria no botão um
     preço que já não é o nosso. */
  var FAMS = null, BADGE = null;
  /* 'gdOptFam2' desde 7-ago: a tabela ganhou `badge.centsComPerso` (emblema a 5,99 com
     nome e número) e a cópia antiga em cache mostraria 7,99 no botão durante 24h. */
  var FAM_KEY = 'gdOptFam2';

  var tabelaAPedir = null;
  function loadTable(cb) {
    if (FAMS) return cb();
    /* duas pinturas concorrentes pediam a tabela duas vezes no arranque */
    if (tabelaAPedir) return tabelaAPedir.then(cb);
    var c = ler(FAM_KEY, TABLE_TTL);
    if (c && c.familias) { FAMS = c.familias; BADGE = c.badge; return cb(); }
    tabelaAPedir = fetch('/apps/options/table', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (j && j.familias) {
          FAMS = j.familias; BADGE = j.badge || null;
          guardar(FAM_KEY, { familias: FAMS, badge: BADGE, at: Date.now() });
        }
      })
      .catch(function () {});
    tabelaAPedir.then(cb);
  }

  /* O gémeo do `surchargeFor` do servidor: mesma tabela, mesma regra do emblema. O que
     aqui se mostra tem de ser exatamente o que o /apps/options/checkout vai cobrar. */
  function suplemento(props, familia) {
    if (!FAMS || !familia || !props) return 0;
    var tab = FAMS[familia];
    if (!tab) return 0;

    /* AS MEIAS VÃO NO PREÇO DOS CALÇÕES — a mesma regra do servidor. Sem ela o botão
       somava-lhes 7,90 que o checkout não cobra, e o cliente chegava lá a pensar que
       tinha desconto. Só vale onde os calções se pagam: num kit, que já os traz, uma
       propriedade «Short: Oui» perdida tornaria as meias grátis sem nada em troca. */
    var normalizados = {};
    for (var nk in props) {
      if (Object.prototype.hasOwnProperty.call(props, nk)) normalizados[normKey(nk)] = normKey(props[nk]);
    }
    var calcoes = tab["short d'equipement"];
    var comCalcoes = !!(calcoes && calcoes.oui > 0 && normalizados["short d'equipement"] === 'oui');

    /* EMBLEMA A 5,99 COM NOME E NÚMERO (7-ago) — a mesma regra do servidor e do gd-sup.
       Sem ela o botão somava 7,99 numa linha em que a ficha dizia 5,99: o total contradizia
       o desconto exatamente no último preço que o cliente vê antes do checkout. O valor
       antigo do YMQ («Nom Numéro et Symbole…») também conta — já inclui personalização. */
    var persoVal = normalizados['personnalisation'] || '';
    var comPerso = persoVal === 'nom et numero' || persoVal === 'nom numero et symbole de la competition';

    var total = 0;
    for (var k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      if (k.charAt(0) === '_') continue;
      var nome = normKey(k), valor = normKey(props[k]);
      if (nome === "chaussettes d'equipement" && comCalcoes) continue;
      if (BADGE && nome === 'symbole de la competition') {
        if (BADGE.familias.indexOf(familia) > -1 && valor && BADGE.vazio.indexOf(valor) < 0) {
          /* tabela velha em cache não traz `centsComPerso`: cai-se no preço cheio, que
             mostra a mais e nunca a menos — e a chave de cache nova reforma essas cópias */
          total += (comPerso && BADGE.centsComPerso) ? BADGE.centsComPerso : BADGE.cents;
        }
        continue;
      }
      var g = tab[nome];
      if (!g) continue;
      var c = g[valor];
      if (typeof c === 'number') total += c;
    }
    return total;
  }

  /* Lê um preço tal como está escrito ("€39,99", "39,99 €", "1 234,56 €") e devolve
     cêntimos + o formato, para o reescrevermos IGUAL. Não assumimos locale nenhum. */
  function readMoney(txt) {
    var m = String(txt).match(/\d[\d\s., ]*\d|\d/);
    if (!m) return null;
    var raw = m[0];
    var dec = null, i = raw.length - 1;
    for (; i >= 0; i--) { if (raw[i] === ',' || raw[i] === '.') { dec = raw[i]; break; } }
    var num = raw.replace(/[\s ]/g, '');
    if (dec) {
      var pos = num.lastIndexOf(dec);
      var ent = num.slice(0, pos).replace(/[.,]/g, '');
      var frac = num.slice(pos + 1);
      if (frac.length > 2) { ent = num.replace(/[.,]/g, ''); frac = ''; dec = null; }
      num = ent + '.' + (frac || '0');
    } else {
      num = num.replace(/[.,]/g, '');
    }
    var cents = Math.round(parseFloat(num) * 100);
    if (!isFinite(cents)) return null;
    return { cents: cents, raw: raw, dec: dec || ',' };
  }

  /* Escreve `cents` no MOLDE de outro preço: copia a moeda, o separador decimal e a
     posição do símbolo do texto que já lá está, em vez de os adivinhar por locale. */
  function moneyComo(cents, modelo) {
    var info = readMoney(modelo);
    if (!info) return null;
    var v = (cents / 100).toFixed(2).replace('.', info.dec);
    /* mantém separador de milhares se o original o tinha */
    if (/[\s ]/.test(info.raw) && cents >= 100000) {
      v = v.replace(/\B(?=(\d{3})+(?!\d)(?=[.,]))/g, ' ');
    }
    return String(modelo).replace(info.raw, v);
  }

  function writeMoney(el, novoCents, info) {
    var txt = moneyComo(novoCents, el.textContent);
    if (txt !== null) el.textContent = txt;
  }

  /* Pinta UM elemento: guarda o texto original na 1ª vez e recalcula sempre a partir
     dele — assim uma repintura nunca soma duas vezes. */
  function bump(el, deltaCents) {
    if (!el || !deltaCents) return;
    /* Já veio certo do servidor (Liquid) — não somar por cima. É isto que permite
       converter o tema ficheiro a ficheiro sem nunca haver preço a dobrar. */
    if (el.closest && el.closest('[data-gd-baked]')) return;
    if (el.hasAttribute && el.hasAttribute('data-gd-baked')) return;
    var orig = el.getAttribute('data-gd-orig');
    if (orig === null) { orig = el.textContent; el.setAttribute('data-gd-orig', orig); }
    else { el.textContent = orig; }
    var info = readMoney(orig);
    if (!info) return;
    writeMoney(el, info.cents + deltaCents, info);
    el.setAttribute('data-gd-painted', '1');
  }

  var pintando = false;
  var cartCache = { at: 0, data: null };

  /* Pintar um preço que não vai ser cobrado é PIOR do que não pintar: o cliente via
     44,98 e pagava 39,99. Por isso a montra segue exatamente quem é cobrado. */
  function vaiSerCobrado() {
    if (!CFG.loaded) return false;
    if (CFG.mode === 'true') return true;
    if (CFG.mode === 'test') return isTester();
    return false;
  }

  /* ⚠️ A montra do carrinho passou a sair do SERVIDOR (`gd-money.liquid`, marcada com
     `data-gd-baked` no main-cart e no mini-cart) — chega certa e sem piscar. Esta pintura
     é o caminho antigo e está parada: a tabela achatada que ela usa deixou de existir
     quando os preços passaram a depender da família, e do lado do cliente não há como
     saber a família de cada linha do carrinho. Fica como rede para superfícies que ainda
     não estejam «baked»; para a reanimar é preciso a família vir na linha. */
  function pintar() {
    if (pintando || !TABLE) return;
    var agora = Date.now();
    var usar = function (cart) {
      if (!cart || !cart.items) return;
      var deltas = cart.items.map(function (li) { return surchargeCents(li.properties) * li.quantity; });
      var totalDelta = deltas.reduce(function (a, b) { return a + b; }, 0);

      if (cart.items.length && !window.__gdReported) {
        window.__gdReported = 1;
        try {
          fetch('/apps/options/debug', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              modo: CFG.mode, cfgLoaded: CFG.loaded, cobra: vaiSerCobrado(), tester: isTester(),
              cookie: hasCookie(), ls: (function(){ try { return localStorage.getItem(TEST_KEY); } catch(_) { return 'bloqueado'; } })(),
              tabela: !!FAMS,
              url: location.pathname,
              linhas: cart.items.map(function (li, i) { return { props: li.properties, delta: deltas[i] }; }),
              achou: {
                ymqKeys: document.querySelectorAll('[data-ymq-item-key]').length,
                drawerLineItem: document.querySelectorAll('#mini-cart .mini-cart__line-item').length,
                drawerWrapper: document.querySelectorAll('#mini-cart .mini-cart__item-wrapper').length,
                miniCart: !!document.getElementById('mini-cart'),
                precoDrawer: document.querySelectorAll('#mini-cart .mini-cart__item-wrapper .price').length,
                totalBtn: document.querySelectorAll('.mc-checkout-total').length,
                totalYmq: document.querySelectorAll('.ymq_cart_total_price').length,
                recap: document.querySelectorAll('.cart-recap__price-line-price').length
              }
            })
          }).catch(function () {});
        } catch (_) {}
      }

      if (!totalDelta || !vaiSerCobrado()) return;

      pintando = true;
      try {
        /* 1) página /cart — os ganchos que o YMQ deixou no tema, casados pela KEY da linha */
        cart.items.forEach(function (li, i) {
          if (!deltas[i]) return;
          var unit = surchargeCents(li.properties);
          document.querySelectorAll('[data-ymq-item-key="' + (window.CSS && CSS.escape ? CSS.escape(li.key) : li.key) + '"]').forEach(function (el) {
            var c = el.className || '';
            if (/final_line_price/.test(c)) bump(el, deltas[i]);
            else if (/final_price|original_price|unit_price|item_price/.test(c)) bump(el, unit);
          });
        });

        /* 2) drawer — não tem ganchos (é mais recente que o YMQ): casamos pela ORDEM,
              que é a mesma do /cart.js */
        var linhas = document.querySelectorAll('#mini-cart .mini-cart__line-item');
        if (!linhas.length) linhas = document.querySelectorAll('#mini-cart .mini-cart__item-wrapper');
        /* casa por ORDEM (é a mesma do /cart.js). Não exigimos contagem igual: se o tema
           acrescentar uma linha de brinde/upsell, pintamos as que dá em vez de desistir. */
        for (var i = 0; i < Math.min(linhas.length, cart.items.length); i++) {
          if (!deltas[i]) continue;
          var pe = linhas[i].querySelector('.price:not(.price--compare)') || linhas[i].querySelector('.price');
          if (pe) bump(pe, deltas[i]);
        }

        /* 3) totais — cada um com o seu seletor, e nenhum a apanhar o que não deve.
              ⚠️ NÃO usar `.cart-recap__price-line-price`: essa classe também está nas
              linhas de DESCONTO, e somar-lhes 4,99 seria um erro caro e silencioso. */

        /* botão do drawer («Payer maintenant · X») */
        document.querySelectorAll('.mc-checkout-total').forEach(function (el) { bump(el, totalDelta); });

        /* /cart — gancho do YMQ, mas SÓ o da linha do total: a mesma classe está no
           aviso de portes grátis, onde o valor é o que FALTA (somar seria ao contrário) */
        document.querySelectorAll('.ymq_cart_total_price').forEach(function (el) {
          if (el.closest && el.closest('.cart-recap__price-line')) bump(el, totalDelta);
        });

        /* drawer — a linha «Total» não tem classe nenhuma; vai-se lá pela estrutura,
           excluindo a linha dos portes (que diz «Gratuite», não é dinheiro nosso) */
        document.querySelectorAll('#mini-cart .mini-cart__recap-price-line').forEach(function (row) {
          if (row.classList.contains('mc-shipping-line')) return;
          var spans = row.querySelectorAll(':scope > span');
          if (spans.length < 2) return;
          bump(spans[spans.length - 1], totalDelta);
        });
      } finally {
        pintando = false;
      }
    };

    if (cartCache.data && agora - cartCache.at < 400) return usar(cartCache.data);
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartCache = { at: Date.now(), data: c }; usar(c); })
      .catch(function () {});
  }

  /* ═══════════════════════════════════════════════════════════════════════
     O PREÇO NO BOTÃO «AJOUTER AU PANIER»
     ═══════════════════════════════════════════════════════════════════════
     O cliente juntava 24,90 € de calções e o botão continuava a dizer o preço da
     camisola — o total só aparecia no carrinho, uma página à frente. Agora o botão diz
     o que vai custar esta linha, e a barra fixa do telemóvel diz o mesmo.

     MESMA REGRA da pintura do carrinho: só se mostra o total quando ele VAI ser cobrado.
     Um botão a prometer 44,98 € com a cobrança desligada é pior do que não dizer nada —
     o cliente compara com o que paga e a diferença é contra nós. */

  function propsDoForm(form) {
    var props = {};
    var campos = form.querySelectorAll('[name^="properties["]');
    for (var i = 0; i < campos.length; i++) {
      var el = campos[i];
      if (el.disabled) continue;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) continue;
      var m = /^properties\[(.*)\]$/.exec(el.name);
      if (m && el.value) props[m[1]] = el.value;
    }
    return props;
  }

  var texto = function (el) { return String(el.textContent || '').replace(/\s+/g, ' ').trim(); };

  function pintarBotao(form) {
    var raiz = q(form, '[data-gd-options]');
    var btn = q(form, '.product-form__add-button');
    if (!raiz || !btn) return;

    /* o rótulo original guarda-se à parte: recalcula-se sempre a partir dele e nunca se
       fica com «Ajouter au panier · 44,98 € · 39,99 €» */
    var rotulo = btn.getAttribute('data-gd-rotulo');
    if (rotulo === null) { rotulo = texto(btn); btn.setAttribute('data-gd-rotulo', rotulo); }

    var base = parseInt(raiz.getAttribute('data-gd-base') || '', 10);
    var molde = raiz.getAttribute('data-gd-base-money') || '';
    var familia = raiz.getAttribute('data-gd-familia') || '';
    var extra = suplemento(propsDoForm(form), familia);

    var novo = rotulo;
    if (FAMS && vaiSerCobrado() && isFinite(base) && molde) {
      var t = moneyComo(base + extra, molde);
      if (t) novo = rotulo + ' · ' + t;
    }
    /* só escreve se MUDOU: o observador do tema reage a cada escrita nossa, e reescrever
       o mesmo texto era um ciclo sem fim */
    if (texto(btn) !== novo) btn.textContent = novo;

    /* a barra fixa mostra o preço do produto — passa a mostrar o mesmo total */
    var sb = document.querySelector('#pdp-stickybar .pdp-stickybar__price b');
    if (sb) {
      if (extra && vaiSerCobrado()) bump(sb, extra);
      else if (sb.getAttribute('data-gd-orig') !== null) sb.textContent = sb.getAttribute('data-gd-orig');
    }
  }

  function pintarBotoes() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      if (q(f, '[data-gd-options]')) pintarBotao(f);
    });
  }

  var pintarTimer = null;
  function agendarPintura(atraso) {
    clearTimeout(pintarTimer);
    pintarTimer = setTimeout(function () { loadTable(function () { pintar(); pintarBotoes(); }); }, atraso == null ? 60 : atraso);
  }

  /* O tema anuncia quando mexe no carrinho. Reagir a ISTO é instantâneo; esperar por
     mutações do DOM com debounce era o que fazia o preço aparecer segundos depois. */
  ['cart:rerendered', 'cart:refresh', 'product:added', 'theme:loading:end'].forEach(function (ev) {
    document.addEventListener(ev, function () { cartCache.at = 0; agendarPintura(0); }, true);
    document.documentElement.addEventListener(ev, function () { cartCache.at = 0; agendarPintura(0); }, true);
  });

  /* O tema re-desenha o drawer a cada alteração do carrinho e apaga a nossa pintura.
     Observamos e voltamos a pintar. O guard `pintando` evita o ciclo infinito. */
  function ligarObservador() {
    if (!window.MutationObserver) return;
    var obs = new MutationObserver(function () { if (!pintando) agendarPintura(); });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
    agendarPintura();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ligarObservador);
  else ligarObservador();

  /* estado visual do botão enquanto preparamos o checkout — sem depender de CSS
     externo (este código também corre na /cart, onde o nosso <style> não existe) */
  function busy(btn, on) {
    if (on) {
      btn.dataset.gdW = btn.style.width || '';
      btn.style.width = btn.offsetWidth + 'px';        /* trava a largura: não "salta" */
      btn.style.opacity = '.72';
      btn.style.pointerEvents = 'none';
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.style.width = btn.dataset.gdW || '';
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
      btn.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('button[name="checkout"]') : null;
    if (!btn) return;

    /* 2ª passagem (fallback): deixa o botão fazer o seu trabalho normal */
    if (btn.dataset.gdGo === '1') { btn.dataset.gdGo = ''; return; }

    /* ─── telemetria das desistências (8-ago-2026) ────────────────────────────────
       Este interceptor tem TRÊS saídas que deixam passar sem cobrar, todas deliberadas
       (mais vale perder €7 do que bloquear um checkout de €40). O problema é caírem em
       SILÊNCIO: 3 encomendas em 7/8-ago (€28,96) ficaram por explicar porque o servidor
       nem soube que houve tentativa. Isto NÃO muda comportamento nenhum — só conta.
       `keepalive` porque a página está a navegar para o checkout neste instante; um
       fetch normal seria cancelado e não saberíamos nada. Nunca pode atrasar nem
       rebentar o checkout: tudo dentro de try/catch e sem `await`. */
    /* `http`/`erro` (18-ago): sem eles, «resposta_invalida» — 4 dos 7 registos — não dizia
       qual das causas foi (draft recusada? opção desconhecida? app em baixo?). O motivo
       vivia só no console.error do servidor, que desaparece no primeiro recreate. */
    var ultimaResposta = { http: null, erro: null };
    function reportarMiss(motivo, extra) {
      try {
        fetch('/apps/options/miss', {
          method: 'POST', credentials: 'same-origin', keepalive: true,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            motivo: motivo, ms: Date.now() - t0, opcoes: extra || null,
            http: ultimaResposta.http, erro: ultimaResposta.erro
          })
        }).catch(function () {});
      } catch (err) { /* telemetria nunca estraga um checkout */ }
    }
    var t0 = Date.now();

    /* config ainda não chegou, ou cobrança desligada → caminho normal, instantâneo */
    if (!CFG.loaded || !CFG.charge) {
      /* só é fuga quando a config NÃO chegou: se a cobrança está desligada não há nada
         a cobrar e o caminho normal é o correto. */
      if (!CFG.loaded) reportarMiss('config_nao_chegou');
      return;
    }

    e.preventDefault(); e.stopImmediatePropagation();
    busy(btn, true);

    var done = false;
    function fallback(motivo) {
      if (done) return; done = true;
      clearTimeout(timer);
      if (motivo) reportarMiss(motivo);
      busy(btn, false);
      btn.dataset.gdGo = '1';
      btn.click();                                     /* checkout normal da Shopify */
    }
    /* rede dura: aconteça o que acontecer, em 8s o cliente vai para o checkout */
    var timer = setTimeout(function () { fallback('timeout_8s'); }, 8000);

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || !cart.items.length) throw new Error('carrinho vazio');
        return fetch('/apps/options/checkout', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: cart.items.map(function (li) {
              return { id: li.variant_id, quantity: li.quantity, properties: li.properties || {} };
            }),
            attributes: cart.attributes || {},   /* utm/landing: sem isto perde-se a atribuição */
            note: cart.note || '',
            test: isTester()
          })
        });
      })
      .then(function (r) { ultimaResposta.http = r.status; return r.json().catch(function () { return null; }); })
      .then(function (j) {
        if (j && j.error) ultimaResposta.erro = String(j.error) + (j.detalhe ? ' · ' + JSON.stringify(j.detalhe).slice(0, 160) : '');
        if (j && j.invoiceUrl) {
          done = true; clearTimeout(timer);
          window.location.href = j.invoiceUrl;
          return;
        }
        /* skip (nada a cobrar / desligado) ou erro → checkout normal.
           `skip` é o caminho CERTO — não há opção paga no carrinho — por isso não conta
           como fuga. Sem esta distinção a telemetria contava todos os checkouts sem
           opções e o número não queria dizer nada. */
        fallback(j && j.skip ? null : 'resposta_invalida');
      })
      .catch(function () { fallback('erro_rede'); });
  }, true);

  /* ─── acessórios do body (cachecol / bandeira) ─────────────────────────────────────
     Ao contrário de tudo o resto nesta ficha, estes NÃO são propriedades da peça: são
     artigos do catálogo. O botão adiciona o produto ao carrinho e deixa o tema abrir o
     carrinho sozinho (`product:added` é o contrato nativo) — assim quem carrega vê logo
     onde a peça foi parar, que é o que impede a confusão com os toggles ao lado.

     Não se toca no formulário da peça de propósito. Interceptar o «Ajouter au panier»
     principal para levar um segundo artigo atrás punha um caminho novo no meio do fluxo
     do checkout (draft orders das opções pagas), e não vale o risco por um acessório. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-gd-acc-add]') : null;
    if (!btn || btn.dataset.gdBusy === '1') return;
    e.preventDefault();
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    btn.dataset.gdBusy = '1';
    var err = btn.parentNode ? btn.parentNode.querySelector('[data-gd-acc-err]') : null;
    if (err) err.hidden = true;
    var url = (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        btn.setAttribute('aria-pressed', 'true');
        btn.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { button: btn, variant: null, quantity: 1, productAdded: true }
        }));
      })
      .catch(function () {
        /* fica clicável outra vez: falhar sem dizer nada é pior do que falhar */
        btn.dataset.gdBusy = '0';
        if (err) err.hidden = false;
      });
  }, false);
})();
